import * as React from 'react';
import {view, deprecatedCss} from '@sail/engine';
import {Radio} from '@sail/ui';

export const Disabled = () => {
  return (
    <view.div
      uses={[
        deprecatedCss`
          layout: column;
        `,
      ]}
    >
      <Radio name="group2" label="Ah ah ah" disabled />
      <Radio
        name="group2"
        disabled
        defaultChecked
        label="You didn't say the magic word"
      />
    </view.div>
  );
};
